module.exports = __webpack_public_path__ + "img/bg-ep-LUX.47c1719e.jpg";